<div class="w-p-100 flex flex-col">
  <div *ngIf="sections.length>0" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Section</mat-label>
      <mat-select required [ngModel]="selectedSection" (selectionChange)="onSelectionChange($event)">
        <mat-option *ngFor="let section of sections" [value]="section">
          {{section.title}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="sections.length>0" class="flex flex-row justify-start items-start auto-flex">
    <mat-checkbox
      [(ngModel)]="isCreateCopyEnabled">
      Create a copy
    </mat-checkbox>
  </div>
  <div *ngIf="sections.length == 0">There is no section to move</div>
</div>


